// Order item 'types'
export const productType = 'product';
export const promotionType = 'promotion';
export const gratuityType = 'gratuity';
export const deliveryChargeType = 'delivery_charge';
export const trayChargeType = 'tray_charge';
export const serviceChargeType = 'service_charge';
export const externalPromotion = 'external_promotion';
